module.exports = __webpack_public_path__ + "img/km.faa0e571.jpg";